import { withInstall } from '@visual-design/utils'
import Row from './src/row.vue'

export const VRow = withInstall(Row)
export default VRow

export * from './src/row'
export * from './src/constants'
